import { render, staticRenderFns } from "./AgreementRuleModal.vue?vue&type=template&id=218a5ced&"
import script from "./AgreementRuleModal.vue?vue&type=script&lang=js&"
export * from "./AgreementRuleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports